// v14ad Fase 0 — Overview view/sort persistentie per module (Klanten,
// Projecten, Offertes, Facturen). Bewaart in localStorage; filters worden
// NIET persistent gehouden (bewuste keuze).
//
// Sleutels:
//   emma:overview:{module}:view  → "list" | "cards"
//   emma:overview:{module}:sort  → string van sort-optie
//
// SSR/no-window guard voor safety (Playwright + CRA test-runner).

import { useCallback, useEffect, useState } from "react";

const KEY = (module, kind) => `emma:overview:${module}:${kind}`;

function readLS(module, kind, fallback) {
  try {
    if (typeof window === "undefined") return fallback;
    const v = window.localStorage.getItem(KEY(module, kind));
    return v == null ? fallback : v;
  } catch {
    return fallback;
  }
}

function writeLS(module, kind, value) {
  try {
    if (typeof window === "undefined") return;
    window.localStorage.setItem(KEY(module, kind), String(value));
  } catch {
    /* localStorage full / blocked → ignore */
  }
}

/**
 * Persisteert de gekozen view + sort per module.
 *
 * @param {string} module   Sleutel voor localStorage (clients/projects/quotes/facturen)
 * @param {string} defaultView   "list" | "cards"
 * @param {string} defaultSort   sort-optie ID
 */
export function useOverviewPreferences(module, defaultView = "cards", defaultSort = "") {
  const [view, setViewState] = useState(() => readLS(module, "view", defaultView));
  const [sort, setSortState] = useState(() => readLS(module, "sort", defaultSort));

  useEffect(() => { writeLS(module, "view", view); }, [module, view]);
  useEffect(() => { writeLS(module, "sort", sort); }, [module, sort]);

  const setView = useCallback((v) => setViewState(v), []);
  const setSort = useCallback((s) => setSortState(s), []);

  return { view, setView, sort, setSort };
}
